export default "__VITE_PUBLIC_ASSET__60bb65e2__"